import {RecordIdHttpModel} from '@dms/api/shared';

import {getApiDateString} from 'shared/web';

import {RecordAuditMetadataFormValue} from './recordAuditMetadataFormSchema';
import {toRecordAuditParticipants} from './toRecordAuditParticipants';

/**
 * Header fields shared by the create and update-header request bodies (everything except the
 * create-only `recordAuditDefinitionId`). Keeps the two body mappers from drifting.
 */
export const toRecordAuditHeaderFields = (
  values: RecordAuditMetadataFormValue,
  pairedRecord: RecordIdHttpModel | null
) => ({
  auditorEmployeeId: values.auditorEmployeeId,
  responsiblePersonEmployeeId: values.responsiblePersonEmployeeId,
  branchId: values.branchId,
  date: getApiDateString(values.date),
  participants: toRecordAuditParticipants(values.participants),
  recordId: pairedRecord,
});
